import { Copy } from 'iconsax-react';
import { useSelector } from 'react-redux';
import { RootState } from '@src/store/store';
import { THEME } from '@src/store/layout/layoutSlice';
import { copyToClipboard } from '@src/utilities/clipboard';
import { useTranslation } from 'react-i18next';

type CopyButtonProps = {
  text?: string;
  successMessage: string;
  className?: string;
};

export function CopyButton({
  text,
  successMessage,
  className,
}: CopyButtonProps) {
  const theme = useSelector((state: RootState) => state.layout.theme);
  const { t } = useTranslation();

  const handleClick = () => {
    if (text) copyToClipboard(text, t, successMessage);
  };

  const isDisabled = !text;

  return (
    <button
      type='button'
      className={`text-black dark:text-white p-0 bg-transparent border-none ${className || ''} ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80 cursor-pointer'}`}
      onClick={isDisabled ? undefined : handleClick}
      aria-label='Copy to clipboard'
      disabled={isDisabled}
    >
      <Copy variant={theme === THEME.LIGHT ? 'Bulk' : 'TwoTone'} />
    </button>
  );
}
